import '../index.scss';
import React, { Component } from 'react';
import { convertUnixtodate, getFieldValue } from '../../shared/services/common-functions';
import LabeledInput from '../../shared/components/labeled-input';
import PropTypes from 'prop-types';
import { getClaimDetails } from '../repositories';
import * as busyCounter from '../../../src/shared/action-creator/busy-counter';
import BusyCounterLoadingIndicator from '../../../src/shared/components/busyCounter/busy-counter-loading-indicator';
import { showLoadingIndicator } from '../../../src/shared/state/busy-counter';
import { connect } from 'react-redux';




class SupplierInformation extends Component {

    state = {
        supplierInfo: [],
        supplierComments: '',
        showLoader:this.props.busyCounter
    }

    componentWillMount = () => {

        this.loadDefault( this.props.claimFor, this.props.claimNumber );

    }

    componentWillReceiveProps ( nextProps ) {

        if ( this.props.claimNumber !== nextProps.claimNumber ||
            this.props.needSupplierInfoUpdate !== nextProps.needSupplierInfoUpdate ) {

            this.loadDefault( this.props.claimFor, nextProps.claimNumber );

        }

    }

    loadDefault = ( mode, id ) => {
        this.setState({showLoader:true})

        getClaimDetails( mode, id ).then( response => {

            if ( response.length > 0 ) {
                this.setState({showLoader:false})

                this.setState( {
                    supplierInfo: response[0],
                    supplierComments: response[0].comments.length === 0 ? '' : response.comments.commentText,
                } );

            } else {
                this.setState({showLoader:false})
                this.setState( {
                    supplierInfo: [],
                    supplierComments: '',
                } );

            }

        } );

    };

    render () {

        const { claimCloseDate, externalSupplierNumber, internalSupplierNumber } =
            this.state.supplierInfo;

        return (
            <div className="machine-info ">
               <BusyCounterLoadingIndicator busyCounter={this.state.showLoader} />
                <section className="generic-machine-information">
      
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="externalSupplierNumber"
                                isEditable={false}
                                label="External Supplier Number"
                                value={getFieldValue( externalSupplierNumber )}
                            />
                        </div>
                        <div className="four-cols">

                            <LabeledInput
                                className="basic-claim-info"
                                name="internalSupplierNumber"
                                isEditable={false}
                                label="Internal Supplier Number"
                                value={getFieldValue( internalSupplierNumber )}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="claimCloseDate"
                                isEditable={false}
                                label="Claim Close Date"
                                value={convertUnixtodate( getFieldValue( claimCloseDate ) )}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="acceptCode"
                                isEditable={false}
                                label="Accept Code"
                                value={getFieldValue( this.state.supplierInfo.acceptCode )}
                            />
                        </div>

                    </div>
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="responsibilityCode"
                                isEditable={false}
                                label="Responsibility Code"
                                value={getFieldValue( `${this.state.supplierInfo.responsibilityCode ? this.state.supplierInfo.responsibilityCode : ''} ${' - '}
                                ${this.state.supplierInfo.responsibilityDescription ? this.state.supplierInfo.responsibilityDescription : ''}` )}
                            />
                        </div>

                        <div className={this.state.supplierInfo.acceptCode !== 'R' ? 'four-cols hide' : 'four-cols'}>
                            <LabeledInput
                                className="basic-claim-info"
                                name="rejectCode"
                                isEditable={false}
                                label="Reject Code"
                                value={getFieldValue( this.state.supplierInfo.rejectedCode )}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="requestedAmount"
                                isEditable={false}
                                label="Requested Amount"
                                value={this.state.supplierInfo.requestedAmount ? `$${getFieldValue( this.state.supplierInfo.requestedAmount )}` : ''}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="acceptedAmount"
                                isEditable={false}
                                label="Accepted Amount"
                                value={this.state.supplierInfo.acceptedAmount ? `$${getFieldValue( this.state.supplierInfo.acceptedAmount )}` : ''}
                            />
                        </div>

                    </div>

                    <div className={this.state.supplierInfo.acceptCode !== 'R' ? 'single-col hide' : 'single-col'}>
                        <LabeledInput
                            className="basic-claim-info"
                            name="rejectReason"
                            isEditable={false}
                            label="Reject Reason"
                            value={getFieldValue( this.state.supplierInfo.rejectedCodeDescription )}
                        />
                    </div>

                    <div className="single-col">
                        <LabeledInput
                            className="basic-claim-info"
                            name="supplierComments"
                            isEditable={false}
                            label="Supplier Comments"
                            value={this.state.supplierComments}

                        />
                    </div>

                </section>
            </div>

        );

    }

}
SupplierInformation.propTypes = {
    claimFor: PropTypes.string.isRequired,
    claimNumber: PropTypes.string.isRequired,
    needSupplierInfoUpdate: PropTypes.bool.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter )
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() )
} );
export default connect(
    mapStateToProps, mapDispatchToProps,
)(SupplierInformation);
